import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Menu, X } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [lang, setLang] = useState('UA');
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Про нас',
    href: '#about'
  }, {
    name: 'Послуги',
    href: '#services'
  }, {
    name: 'Відгуки',
    href: '#testimonials'
  }];
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-background/80 backdrop-blur-lg border-b border-border py-4' : 'bg-transparent py-6'}`} data-id="element-107">
      <div className="max-w-7xl mx-auto px-6 flex justify-between items-center" data-id="element-108">
        <a href="#" className="text-xl font-semibold tracking-tight text-primary" data-id="element-109">
          Адвокат
        </a>

        <div className="hidden md:flex items-center gap-8" data-id="element-110">
          <div className="flex gap-6" data-id="element-111">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-secondary hover:text-primary transition-colors" data-id="element-112">
                {link.name}
              </a>)}
          </div>

          <a href="#contact" className="px-5 py-2.5 bg-primary text-background text-sm font-medium rounded-full hover:opacity-90 transition-opacity" data-id="element-113">
            Зв'язатися
          </a>
        </div>

        <div className="md:hidden flex items-center gap-4" data-id="element-114">
          <button className="text-primary p-1" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-115">
            {isMobileMenuOpen ? <X size={24} data-id="element-116" /> : <Menu size={24} data-id="element-117" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="absolute top-full left-0 w-full bg-background border-b border-border p-6 flex flex-col gap-4 md:hidden shadow-lg" data-id="element-118">
          {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-lg font-medium text-primary py-2" data-id="element-119">
              {link.name}
            </a>)}
          <a href="#contact" onClick={() => setIsMobileMenuOpen(false)} className="mt-4 px-6 py-3 bg-primary text-background text-center font-medium rounded-full" data-id="element-120">
            Зв'язатися
          </a>
        </div>}
    </motion.nav>;
}